import { render, staticRenderFns } from "./CompetitionProgramFormItem.vue?vue&type=template&id=6cd90736&scoped=true&"
import script from "./CompetitionProgramFormItem.vue?vue&type=script&lang=js&"
export * from "./CompetitionProgramFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionProgramFormItem.vue?vue&type=style&index=0&id=6cd90736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd90736",
  null
  
)

export default component.exports